import React from 'react';
import { TableEditColumn } from '@devexpress/dx-react-grid-material-ui';

const EditCommandColumnCell = (props) => {
	const { row } = props;

	if (!!row.isFromApi) {
		const { children, ...restProps } = props;
		const newChildren = React.Children.map(children, (child) => {
			if (
				!!child &&
				(child.props.id === 'commit' ||
					child.props.id === 'cancel' ||
					(!!row.isCanBeEdited && child.props.id === 'edit') ||
					(!!row.isCanBeDeleted && child.props.id === 'delete'))
			)
				return child;

			return null;
		});
		return <TableEditColumn.Cell {...restProps}>{newChildren}</TableEditColumn.Cell>;
	}

	return <TableEditColumn.Cell {...props} />;
};

export default EditCommandColumnCell;
